import { motion } from 'framer-motion';
import { CounterUp } from './CounterUp';

/* ═══════════════════════════════════════════
   EDITABLE: About section content
═══════════════════════════════════════════ */
const ABOUT_LABEL = 'About Company';
const ABOUT_HEADING = 'Trusted Financial Consultants in Mumbai | 30+ Years of Experience';
const ABOUT_PARAGRAPH_1 = 'With a strong presence in Mumbai, Ashwamedh Financial Services has proudly served over 5,000 clients through mutual fund plans, insurance solutions, and tax-saving strategies since 1991. We are recognized as one of the most trusted financial advisory firms in the Dadar area.';
const ABOUT_PARAGRAPH_2 = 'Our signature offerings — Sampoorna Suraksha and our comprehensive Goal Achievement Programme — have helped thousands of families stay financially prepared for life\'s key milestones including education, marriage, retirement, and wealth transfer.';
const ABOUT_BUTTON_TEXT = 'Know More';
const ABOUT_BUTTON_LINK = '#services';
const ABOUT_IMAGE = 'https://images.unsplash.com/photo-1776964176603-3cf29bcb47d1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzN8MHwxfHNlYXJjaHwzfHxNdW1iYWklMjBzZWElMjBsaW5rJTIwc2t5bGluZSUyMGNvYXN0JTIwYWVyaWFsfGVufDB8fHx8MTc3ODA0NjI1M3ww&ixlib=rb-4.1.0&q=85';
const COUNTER_YEARS = 30;

export const AboutSection = () => {
  return (
    <section id="about" data-testid="about-section" className="py-20 md:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-20">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          {/* Left - Content */}
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: '-80px' }}
            transition={{ duration: 0.7 }}
          >
            <p className="text-xs tracking-[0.25em] uppercase font-bold text-[#D4AF37] mb-4">
              {ABOUT_LABEL}
            </p>
            <h2 className="font-['Playfair_Display'] text-3xl sm:text-4xl font-bold text-[#0A192F] leading-tight mb-6">
              {ABOUT_HEADING}
            </h2>
            <p className="text-sm sm:text-base text-[#49566B] leading-relaxed mb-4 font-['Outfit']">
              {ABOUT_PARAGRAPH_1}
            </p>
            <p className="text-sm sm:text-base text-[#49566B] leading-relaxed mb-8 font-['Outfit']">
              {ABOUT_PARAGRAPH_2}
            </p>
            <a
              href={ABOUT_BUTTON_LINK}
              data-testid="about-know-more-btn"
              className="inline-block px-8 py-3 bg-[#0A192F] text-[#D4AF37] font-semibold rounded-full hover:scale-105 hover:shadow-lg transition-all duration-300 border border-[#D4AF37]/30"
            >
              {ABOUT_BUTTON_TEXT}
            </a>
          </motion.div>

          {/* Right - Image + Counter */}
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: '-80px' }}
            transition={{ duration: 0.7 }}
            className="relative"
          >
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <img
                src={ABOUT_IMAGE}
                alt="Ashwamedh Financial Services"
                className="w-full h-[400px] lg:h-[500px] object-cover"
                data-testid="about-image"
              />
              {/* Counter Badge */}
              <div className="absolute bottom-6 left-6 bg-[#0A192F] rounded-xl p-5 shadow-xl" data-testid="about-counter-badge">
                <p className="font-['Playfair_Display'] text-4xl font-bold text-[#D4AF37]">
                  <CounterUp end={COUNTER_YEARS} suffix="+" />
                </p>
                <p className="text-sm text-white/80 mt-1 font-['Outfit']">Years of Experience</p>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
